import { FaFolderOpen } from "react-icons/fa";
import { ProjectsViewMain } from "../Components/ProjectsViewMain";
import { ProjectDetailViewMain } from "../Components/ProjectDetailViewMain";
import { SubProjectDetailViewMain } from "../Components/SubProjectDetailViewMain";
import { GuideDetailViewMain } from "../Components/GuideDetailViewMain";

export const ProjectsModule = (DATA_USER_AUTH = null) => {

    return [
        {
            views: "PRIVATE", path: "/projects", component: <ProjectsViewMain />,
            roles: null, permissions: null, label: "Proyectos", icon: <FaFolderOpen />,
            displayInHeader: false, displayInFooter: false, displayInSidebar: true,
            isBlockedWhenLogged: false
        },
        {
            views: "PRIVATE", path: "/projects/:id", component: <ProjectDetailViewMain />,
            roles: null, permissions: null, label: "Detalle de proyecto", icon: null,
            displayInHeader: false, displayInFooter: false, displayInSidebar: false,
            isBlockedWhenLogged: false
        },
        {
            views: "PRIVATE", path: "/projects/:id/guides/:guideId", component: <GuideDetailViewMain />,
            roles: null, permissions: null, label: "Detalle de guia", icon: null,
            displayInHeader: false, displayInFooter: false, displayInSidebar: false,
            isBlockedWhenLogged: false
        },
        {
            views: "PRIVATE", path: "/projects/:id/subprojects/:subId/guides/:guideId", component: <GuideDetailViewMain />,
            roles: null, permissions: null, label: "Detalle de guia", icon: null,
            displayInHeader: false, displayInFooter: false, displayInSidebar: false,
            isBlockedWhenLogged: false
        },
        {
            views: "PRIVATE", path: "/projects/:id/:tab", component: <ProjectDetailViewMain />,
            roles: null, permissions: null, label: "Detalle de proyecto", icon: null,
            displayInHeader: false, displayInFooter: false, displayInSidebar: false,
            isBlockedWhenLogged: false
        },
        {
            views: "PRIVATE", path: "/projects/:id/subprojects/:subId", component: <SubProjectDetailViewMain />,
            roles: null, permissions: null, label: "Detalle de subproyecto", icon: null,
            displayInHeader: false, displayInFooter: false, displayInSidebar: false,
            isBlockedWhenLogged: false
        },
        {
            views: "PRIVATE", path: "/projects/:id/subprojects/:subId/:tab", component: <SubProjectDetailViewMain />,
            roles: null, permissions: null, label: "Detalle de subproyecto", icon: null,
            displayInHeader: false, displayInFooter: false, displayInSidebar: false,
            isBlockedWhenLogged: false
        },

    ]
};
